export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  // The click is synchronous, but Safari needs the URL to outlive the current task.
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
